var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sun-progress"},[_c('div',{staticClass:"outer",style:({
            height: _vm.barHeight + 'px',
            'border-radius': _vm.barHeight / 2 + 'px',
            background: _vm.outerColor
        })},[_c('div',{staticClass:"inner",style:({
                width: _vm.per + '%',
                height: _vm.barHeight + 'px',
                'border-radius': _vm.barHeight / 2 + 'px',
                background: _vm.innerColor
            })})]),_vm._v(" "),(_vm.triangle)?_c('div',{staticClass:"triangle-box",style:({
            left: _vm.per + '%',
            'margin-left': '-20px',
            background: _vm.innerColor
        })},[_c('p',[_vm._v(_vm._s(_vm.per)+"%")]),_vm._v(" "),_c('p',{staticClass:"triangle",style:({ 'border-bottom': '8px solid ' + _vm.innerColor })})]):_c('p',{staticClass:"text-center only-num"},[_vm._v(_vm._s(_vm.per)+"%")])])}
var staticRenderFns = []

export { render, staticRenderFns }